import React from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';

import Recommendation from './Recommendation';

const Formula = ({ code, value, formulaSelected, formulasRecommended, strings }) => (
  <div className="flex-grid flex-grid-center-horizontal">
    <div className="flex-row-custom">
      {code === formulasRecommended && <Recommendation strings={strings} />}
      <div
        className={cn('style-item-formulas padding-box', {
          selected_item: code === formulaSelected,
        })}
      >
        <span className="text-weight text-uppercase"> {value} </span>
      </div>
    </div>
  </div>
);

Formula.propTypes = {
  code: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  formulaSelected: PropTypes.string,
  formulasRecommended: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  strings: PropTypes.object,
};

Formula.defaultProps = {
  formulaSelected: undefined,
  formulasRecommended: undefined,
  strings: {},
};

export default Formula;
